import axios from 'axios'
import { CustomException } from '../utils/exceptions'

export const getModeles = async params => {
  const modeles = await axios.get('/admin/selectionModele/getAll', { params })
    .catch((e) => {
      throw new CustomException(e, 'Error fetching selection modeles')
    })
  return modeles.data
}

export const getModele = async id => {
  let params = { id: id }
  const modele = await axios.get('/admin/selectionModele/get', { params })
    .catch((e) => {
      throw new CustomException(e, 'Error fetching selection modele')
    })
  return modele.data
}

export const enregistreModele = async modeleData => {
  const modele = await axios.post('/admin/selectionModele/post', modeleData)
    .catch((e) => {
      throw new CustomException(e, 'Error persisting selection modele')
    })

  return modele.data
}

export const supprimeModele = async id => {
  let params = { id: id }
  await axios.delete('/admin/selectionModele/delete', { params })
    .catch((e) => {
      throw new CustomException(e, 'Error deleting selection modele')
    })
}
